<div class="page-header">
    <!-- logo Hub -->
    <div class="row">
        <div class="col-lg-12 col-xs-12 col-md-12 col-sm-12" id="entete-hub">
            <div>
                <div class="col-lg-6 col-md-6 col-xs-6 col-sm-6" id="array-logoGS1">
                    <a target="_blank" href="http://www.gs1.fr"><img src="assets/images/icons/hub/GS1_France_2014-12-17.svg" class="logo_gs1"></a>
                    <p class="Title-page">Mon Espace Client</p>
                </div>
            </div>
        </div>
    </div>
</div>



